import * as React from 'react';
import { cva, VariantProps } from 'class-variance-authority';
import { X } from 'lucide-react';

import { Button } from './';
import { cn } from '@app/shared/utils/common';

const buttonVariants = cva('flex shrink-0 h-8 w-8 items-center justify-center rounded-full', {
  variants: {
    variant: {
      lightblue: 'bg-blue-primary',
      lightgrey: 'bg-icon',
      dark: 'bg-[#3E3B3B99] text-[#FFF]',
    },
  },
  defaultVariants: {
    variant: 'lightgrey',
  },
});

interface CloseButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>, VariantProps<typeof buttonVariants> {}

const CloseButton = React.forwardRef<HTMLButtonElement, CloseButtonProps>(
  ({ type = 'button', variant, className, ...props }, ref) => {
    return (
      <Button
        type={type}
        variant="custom"
        className={cn(buttonVariants({ variant, className }))}
        ref={ref}
        {...props}
      >
        <X className="color-black h-5 w-5" />
      </Button>
    );
  }
);
CloseButton.displayName = 'CloseButton';

export { CloseButton };
